class Item {
    constructor() {
    }

    isCreated() {
        return this.ipfsHash !== undefined || this.name !== undefined;
    }
    getName() {}
    getId() {}
}

export default Item;
